"use strict";
/**
 * KILT's core functionalities are exposed via connecting to its blockchain.
 *
 * To connect to the blockchain:
 * ```Kilt.connect('ws://localhost:9944');```.
 *
 * @packageDocumentation
 * @module Kilt
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnect = exports.init = exports.config = exports.connect = void 0;
const config_1 = require("@kiltprotocol/config");
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
const identity_1 = require("../identity");
function connect() {
    return chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
}
exports.connect = connect;
function config(configs) {
    config_1.ConfigService.set(configs);
}
exports.config = config;
/**
 * Prepares crypto modules (required e.g. For identity creation) and calls Kilt.config().
 *
 * @param configs Arguments to pass on to Kilt.config().
 * @returns Promise that must be awaited to assure crypto is ready.
 */
async function init(configs) {
    config(configs || {});
    await identity_1.Identity.cryptoWaitReady();
}
exports.init = init;
exports.disconnect = chain_helpers_1.BlockchainApiConnection.disconnect;
exports.default = {
    connect,
    disconnect: exports.disconnect,
    config,
    init,
};
